if (!customElements.get("cart-complete")) {
  customElements.define(
    "cart-complete",
    class CartComplete extends HTMLElement {
      constructor() {
        super();
        this.identify = this.dataset.identify || "";


        // reload 购物车后, 重新更新赠品候选列表
        if (this.identify == 'FreeGift') {
          document.addEventListener(
            'theme:cart:reload',
            function () {
              this.updateGiftListVisable(this);
            }.bind(this)
          );
        }
      }

      handleCartUpdate() {
        fetch(window.Shopify.routes.root + "?section_id=api-cart-drawer")
          .then((res) => {
            const result = res.text();
            return result;
          })
          .then((result) => {
            let fresh = document.createElement("div");
            fresh.innerHTML = result;
            if (this.identify == 'FreeGift') {
              this.updateGiftListVisable(fresh);
            }
            this.innerHTML =
              fresh.querySelector(`cart-complete[data-identify=${this.identify}]`).innerHTML;
            fresh = undefined;
          });
      }

      /**
       * 更新阶梯式满赠的赠品候选列表的可见性
       * @param {HTMLElement} element 
       * @returns 
       */
      updateGiftListVisable(element) {
        const jsonElement = element.querySelector('[data-cart-free-gift-json]');
        if (!jsonElement) return;
        const jsonData = JSON.parse(jsonElement?.innerHTML);
        /** 购物车里的赠品列表 (handle 形式) */
        const cartItemsGiftList = jsonData.cart_gift_list;

        /** 赠品候选列表分组 */
        const itemList = element.querySelectorAll('[data-step-spend]');
        if (itemList.length == 0) return;
        /** 除开赠品后的购物车总价（无小数位形式, 含汇率） */
        let cartPriceNoGift = jsonData.cart_subtotal_no_gift;
        /** 当前购物车符合的 Gift step 条件 */
        let currentGiftStep = this._getCurentGiftStep(cartPriceNoGift);

        // 只显示满足当前满赠条件的赠品候选列表分组
        // 并且, 购物车如果已经有当前满赠条件的赠品, 不显示赠品候选列表
        for (const item of itemList) {
          if (currentGiftStep == undefined) {
            item.classList.add('hidden');
            continue;
          }
          const spendPrice = Number(item.getAttribute('data-step-spend'));
          if (spendPrice == currentGiftStep.minimum_price_not_rate) {
            this._cartHasCurrentStepGift(cartItemsGiftList, currentGiftStep)
              ? item.classList.add('hidden')
              : item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        }
      }

      /**
       * 购物车是否包含指定条件的赠品
       * @param {String[]} cartItemsGiftList 购物车里的赠品列表 (handle 形式)
       * @param {*} giftStep 单个满赠条件
       */
      _cartHasCurrentStepGift(cartItemsGiftList, giftStep) {
        // console.log('_cartHasCurrentStepGift: ', cartItemsGiftList, giftStep);
        if (cartItemsGiftList.length == 0) return false;
        let has = false;
        for (const step_gift_product of giftStep.gift_products) {
          if (cartItemsGiftList.includes(step_gift_product.handle)) {
            has = true;
          }
        }
        return has;
      }

      /** 获取当前购物车符合的 Gift step 条件
       * @param {number} cartPriceNoGift 购物车总价 (排除所有赠品价格)
       */
      _getCurentGiftStep(cartPriceNoGift) {
        let currentGiftStep = undefined;
        const steps = window.cartGiftSettings.steps;
        // 获取当前购物车符合条件的 Gift step
        for (const step of steps) {
          if (step.minimum_price <= cartPriceNoGift && (currentGiftStep == undefined || currentGiftStep.minimum_price < step.minimum_price)) {
            currentGiftStep = step;
          } else {
            break;
          }
        }
        return currentGiftStep;
      }
    }
  );
}
